// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-preview[data-v-3f17c97d]{position:sticky;top:100px}", ""]);
// Exports
module.exports = exports;
